import React from "react";

export default function HeroSection() {
    // CSS for background images
    const backgroundStyle = {
        '--desktop-bg': 'url("/assets/images/hero-bg-img.webp")',
        '--mobile-bg': 'url("/assets/images/herosection.webp")',
    };

    return (
        <section 
            className="bg-white w-full overflow-hidden font-poppins py-8 sm:py-12 md:py-16 lg:py-20 min-h-[500px] sm:min-h-[600px] lg:min-h-[700px] relative before:content-[''] before:absolute before:inset-0 before:bg-[image:var(--mobile-bg)] md:before:bg-[image:var(--desktop-bg)] before:bg-cover before:bg-center before:bg-no-repeat"
            style={backgroundStyle}>
            {/* Dark overlay for mobile */}
            <div className="absolute inset-0 bg-black/70 md:hidden"></div>
            {/* Gradient overlay for desktop */}
            {/* <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/90 to-transparent z-[1] hidden md:block"></div> */}
           
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 h-full relative z-[2]">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 items-start md:items-center h-full">
                    {/* Left Content */}
                    <div className="text-center md:text-left relative z-10 max-w-xl mx-auto md:mx-0 mt-16 md:mt-0">
                        <span className="inline-block bg-white rounded-md px-3 sm:px-5 py-1.5 sm:py-2 text-xs sm:text-sm text-[#041C77] font-medium mb-3 sm:mb-4">
                            Your Trusted Real Estate Partner
                        </span>

                        {/* Heading and Paragraph */}
                        <div className="space-y-3 sm:space-y-4 md:space-y-5">
                            {/* Mobile Heading */}
                            <div className="md:hidden">
                                <h1 className="text-3xl leading-tight text-white font-semibold">
                                    Discover Your
                                    <span className="text-white font-bold block mt-1">
                                        Perfect Home
                                    </span>
                                </h1>
                                <p className="text-white text-sm leading-relaxed mt-4 max-w-[280px] mx-auto">
                                    Find the best properties that match your lifestyle and dreams. Let us guide you home.
                                </p>
                            </div>

                            {/* Desktop Heading */}
                            <div className="hidden md:block">
                                <h1 className="text-4xl lg:text-5xl leading-tight text-[#000000] font-semibold">
                                    Find Your Perfect
                                    <br />
                                    <span className="text-[#041C77] font-bold">
                                        Dream Home Today
                                    </span>
                                </h1>
                                <p className="text-[#212121] text-base leading-relaxed max-w-2xl mt-4">
                                    Discover exceptional properties tailored to your lifestyle. Our expert team combines market knowledge with personalized service to help you make informed real estate decisions. Whether buying, selling, or investing, we're here to guide you every step of the way.
                                </p>
                            </div>
                        </div>

                        {/* Buttons */}
                        <div className="flex flex-wrap justify-center md:justify-start gap-3 sm:gap-4 mt-6 sm:mt-8">
                            <a
                                href="#about"
                                onClick={(e) => {
                                    e.preventDefault();
                                    const aboutSection = document.getElementById('about');
                                    if (aboutSection) {
                                        aboutSection.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}
                                className="px-6 py-3 rounded-full bg-[#041C77] text-white text-sm sm:text-base font-semibold shadow-lg transition hover:bg-[#032299] active:bg-[#021a77] inline-block"
                            >
                                View Properties
                            </a>
                            <a
                                href="#contact"
                                onClick={(e) => {
                                    e.preventDefault();
                                    const contactSection = document.getElementById('contact');
                                    if (contactSection) {
                                        contactSection.scrollIntoView({ behavior: 'smooth' });
                                    }
                                }}
                                className="px-6 py-3 rounded-full bg-white border-2 border-white md:border-[#041C77] text-[#041C77] text-sm sm:text-base font-semibold transition inline-block hover:bg-[#041C77] hover:text-white hover:border-[#041C77]"
                            >
                                Free Consultation
                            </a>
                        </div>
                    </div>

                    {/* Optional: Add an image for larger screens */}
                    <div className="hidden md:block relative z-10">
                        {/* You can add a hero image here if needed */}
                    </div>
                </div>
            </div>
        </section>
    );
}
